(function ($) {
  const source = document.currentScript?.dataset.librarySrc;
  if (!$?.fn || !source || $.fn.zoom?.homeaxLazy) return;

  const hasHoverPointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  const targets = new WeakMap();
  let originalZoom;
  let loading;

  function loadLibrary() {
    if (originalZoom) return Promise.resolve(originalZoom);
    if (loading) return loading;
    loading = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.src = source;
      script.onload = () => {
        originalZoom = $.fn.zoom;
        $.fn.zoom = lazyZoom;
        if (typeof originalZoom !== 'function' || originalZoom === lazyZoom) {
          originalZoom = undefined;
          loading = undefined;
          script.remove();
          reject(new Error('Zoom library did not initialize'));
          return;
        }
        resolve(originalZoom);
      };
      script.onerror = () => {
        loading = undefined;
        script.remove();
        reject(new Error('Zoom library could not be loaded'));
      };
      document.head.appendChild(script);
    });
    return loading;
  }

  function activate(target, state, event) {
    if (!hasHoverPointer.matches || !target.isConnected || !target.matches(':hover')) return;
    loadLibrary().then((zoom) => {
      if (!hasHoverPointer.matches || !target.isConnected || !target.matches(':hover')) return;
      const image = target.querySelector('img[data-master-image]');
      const url = image?.dataset.masterImage || state.options.url;
      if (!url || state.url === url) return;
      if (state.url) $(target).trigger('zoom.destroy');
      state.url = url;
      const callback = state.options.callback;
      zoom.call($(target), Object.assign({}, state.options, {
        url,
        touch: false,
        callback: function () {
          if (typeof callback === 'function') callback.call(this);
          // Replay the first hover after the library and full-size image load.
          if (target.isConnected && target.matches(':hover') && state.url === url && event) {
            $(target).trigger($.Event('mouseenter.zoom', { pageX: event.pageX, pageY: event.pageY }));
          }
        }
      }));
    }).catch(() => {}); // Retry on a later hover; the normal gallery stays usable.
  }

  function lazyZoom(options) {
    return this.each(function () {
      const target = this;
      let state = targets.get(target);
      if (!state) {
        state = { options: {}, url: null };
        targets.set(target, state);
        $(target).on('zoom.destroy.homeax', () => { state.url = null; });
        target.addEventListener('mouseenter', (event) => {
          state.lastEvent = event;
          activate(target, state, event);
        });
      }
      state.options = options || {};
      const url = target.querySelector('img[data-master-image]')?.dataset.masterImage || state.options.url;
      if (state.url && state.url !== url) {
        $(target).trigger('zoom.destroy');
        state.url = null;
      }
      if (!state.url && state.lastEvent) activate(target, state, state.lastEvent);
    });
  }

  lazyZoom.homeaxLazy = true;
  $.fn.zoom = lazyZoom;
})(window.jQuery);
